import { SpanProcessor } from '@opentelemetry/sdk-trace';
import { UAParser } from 'ua-parser-js';
import { ATTR_USER_AGENT_ORIGINAL } from '@opentelemetry/semantic-conventions';

// Custom browser attributes (no semantic conventions available)
export const CUSTOM_ATTRIBUTES = {
  USER_AGENT_VERSION: 'user_agent.version',
  USER_AGENT_NAME: 'user_agent.name'
};

const getBrowserInfo = () => {
  // You can add your custom browser tracking logic here as well.
  // This example uses the ua-parser-js package.
  const parser = new UAParser();
  const result = parser.getResult();
  return {
    userAgentOriginal: result.ua || '',
    userAgentVersion: result.browser.version || '',
    userAgentName: result.browser.name || ''
  };
};

const CustomSpanProcessor: SpanProcessor = {
  onStart: (span) => {
    const browserInfo = getBrowserInfo();

    if (navigator.userAgent) {
      span.setAttribute(ATTR_USER_AGENT_ORIGINAL, navigator.userAgent);
    }

    // Browser information (custom attributes - no semantic conventions available)
    span.setAttribute(CUSTOM_ATTRIBUTES.USER_AGENT_VERSION, browserInfo.userAgentVersion);
    span.setAttribute(CUSTOM_ATTRIBUTES.USER_AGENT_NAME, browserInfo.userAgentName);
  },
  onEnd: () => Promise.resolve(),
  forceFlush: () => Promise.resolve(),
  shutdown: () => Promise.resolve()
};

export default CustomSpanProcessor;
